// extracted by mini-css-extract-plugin
export default {"button":"QRCodeView_button__v19II"};